import { load } from 'recaptcha-v3';
import DomainChecker from '../index';

export interface DomainSuggestions {
    prefix: string;
    suffixes: string[];
}

export interface Price {
    period: number;
    price: string;
    originalPrice: string;
}

export type Pricing = Price[];

export interface DomainResponse {
    currency: string;
    taxLabel: string;
    isAvailable: boolean;
    formattedPrice: string;
    formattedYearlyPrice: string | null;
    success: boolean;
    error: string;
    pricing: Pricing;
    domainSuggestions: DomainSuggestions;
}

export const FetchDomain = async (domainName: string, locale: string, limit = 5): Promise<DomainResponse> => {
    const url = window.location.hostname.includes('rocketspark.com') ? DomainChecker.PRODUCTION_FETCH : DomainChecker.DEVELOPMENT_FETCH;
    try {
        const recaptcha = await load('6LeGEJQsAAAAAAGYB8b0x60dkE0YKX16ajVCUBsH');
        const token = await recaptcha.execute('domainRegister');
        const rsKey = new URLSearchParams(location.search).get('rsKey');
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                countryCode: locale,
                domain: domainName,
                rsKey: rsKey,
                suggestionsLimit: limit.toString(),
                'g-recaptcha-response': token
            })
        });
        return response.json();
    } catch (err) {
        console.error(err);
        throw new Error(err);
    }
};
